var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3.96,
  height: 18,
  x: 10.02,
  y: -3.98,
  rx: 1.25,
  transform: "rotate(-90 12 5.02)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 14h2v6.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14h2a.5.5 0 0 0 .35-.85l-4-4a.48.48 0 0 0-.7 0l-4 4A.5.5 0 0 0 8 14Zm3-4"
})));
export default SvgUpload;